// extracted by mini-css-extract-plugin
module.exports = {"map":"Card_map__315js","wrapper":"Card_wrapper__3XFhh","clickable":"Card_clickable__enbxq","full":"Card_full__Mxp_c","touchable":"Card_touchable__3g5b2"};